// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K2lKy","type":"styles_type__FS-YR","choices":"styles_choices__3RCqE"};